export default "__VITE_ASSET__DvMbMZGD__";